import { BrowserRouter, Navigate } from "react-router-dom";
import { Routes, Route } from "react-router-loading";
import { OnboardingStepProvider, useOnboardingStep } from "./context/OnboardingStepContext";
import { getRegisterFlowData } from "./utils/registerFlowStore";
import OnboardingMain from "./components/PublisherProfile/Onboarding/OnboardingMain";
import Cookies from "js-cookie";


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './App.css';
// import "./styles/login.css"
// import "./styles/register.css"
// import "./styles/custom.css"

import {
  Header,
  // Login, // route commented out
  // Register,
  Onboarding,
  // Dashboard, // route commented out
  // ZoneCreate, // route commented out
  PublisherListing,
  ZoneListing,
  // AdTxtUpload, // route commented out
  NoPageComponent,
  MediaPlanner,
  MyProfile,
  // MyProfileV2, // route commented out
  AdminUserList,
  SiteListingFreewheel,
  SiteListingPubmatic,
  RemoteFeedListing,
  AdvertiserListing,
  ExtendedUserListing,
  CampaignListGam,
  IpListing,
  AppBundleListing,
  CategoryListing,
  // PublisherDomainListing, // route commented out
  Reporting,
  AdminTagList,
  GamAutomationList,
  AdminDomainList,
  // SavedReports, // route commented out
  AdminCheckAdcodesList,
  CTVMediaPlanner,
  AdminCtvCsvUploadList,
  UserSyncReport,
  InventoryListing,
  BrandSafety,
  BasicSetting,
  GeneralSetting,
  AccountSetting,
  InventorySetting,
  AdsTxtMobileOps,
  AdsTxtPublisher,
  AppAdsTxtPublisher,
  ReportV2,
  DashboardV2,
  LoginV2,
  SignupV2,
  MediaPlannerV2,
  Healthcenter,
  KnowledgeBase,
  UprMapper

  // PublisherUserList // route commented out
} from "./components";


// UI design imports — all routes are commented out
// import LoginUI from "./design/login-and-signup/LoginUI.jsx";
// import LoginComponents from "./design/login-and-signup/components/LoginComponents.jsx";
// import SignupUi from "./design/login-and-signup/SignupUi.jsx";
// import OtpUi from "./design/login-and-signup/OtpUi.jsx";
// import OnboardingUi from "./design/onboarding/OnboardingUi.jsx";
// import OnboardingComponents from "./design/onboarding/components/OnboardindComponents.jsx";
// import OnboardingFormUi from "./design/onboarding/OnboardingFormUi.jsx";
// import OnboardingMessageUi from "./design/onboarding/OnboardingMessageUi.jsx";
// import PubslishersListingUi from "./design/publishers-listing/components/PubslishersListingUi.jsx";
// import CreateZoneUi from "./design/zone/CreateZoneUi.jsx";
// import Components from "./design/components/Components.jsx";
// import ZoneListingUi from "./design/zone/ZoneListingUi.jsx";
// import GamUi from "./design/zone/GamUi.jsx";
// import AdsTxt from "./design/publishers-listing/components/AdsTxt.jsx";
// import LoaderDesign from "./design/components/LoaderDesign.jsx";
// import ImportUi from "./design/publishers-listing/ImportUi.jsx";
// import ImportZoneUi from "./design/zone/ImportZoneUi.jsx";
// import SitesTable from "./design/sites/SitesTable.jsx";
// import SitesForm from "./design/sites/SitesForm.jsx";
// import SiteCreateZone from "./design/sites/SiteCreateZone.jsx";
// import SiteRemoteForm from "./design/sites/SiteRemoteForm.jsx";
// import MultipleSelect from "./design/components/MultipleSelect.jsx";
// import AddonForm from "./design/sites/AddonForm.jsx";
// import PubMaticWeb from "./design/pubmatic/PubMaticWeb.jsx";
// import PubMaticApp from "./design/pubmatic/PubMaticApp.jsx";
// import PubMaticCtv from "./design/pubmatic/PubMaticCtv.jsx";
// import CreateTag from "./design/pubmatic/createtag/CreateTag.jsx";
// import CreateTag2 from "./design/pubmatic/createtag/CreateTag2.jsx";
// import FirstForm from "./design/createcampaign/FirstForm.jsx";
// import SecondForm from "./design/createcampaign/SecondForm.jsx";
// import ThirdForm from "./design/createcampaign/ThirdForm.jsx";
// import ForthForm from "./design/createcampaign/ForthForm.jsx";
// import FiveFormTable from "./design/FiveTableForm/FiveFormTable.jsx";
// import ExcludedCategoriesForm from "./design/FiveTableForm/ExcludedCategoriesForm.jsx";
// import IpList from "./design/FiveTableForm/IpList.jsx";
// import NewExtendedUserList from "./design/FiveTableForm/NewExtendedUserList.jsx";
// import CreateAppBundleList from "./design/FiveTableForm/CreateAppBundleList.jsx";
// import MediaPlannerFilter from "./design/mediaplanner/MediaPlannerFilter.jsx";
// import GamTable from "./design/gamtable/GamTable.jsx";
// import EditCampaign from "./design/editcampaign/EditCampaign.jsx";
// import MediaPlannerListing from "./design/mediaplanner/MediaPlannerListing.jsx";
// import FifthForm from "./design/createcampaign/FifthForm.jsx";
// import CreateAdvertiser from "./design/createadvertiser/CreateAdvertiser.jsx";
// import NewPublishersForm from "./design/PublishersForm/NewPublishersForm";
// import NewInventoryPage from "../src/components/NewInventoryPage.jsx";
// import NewBrandSafety from "./design/Setting/NewBrandSafety.jsx";
// import NewMyAccount from "./design/Setting/NewMyAccount.jsx";
// import NewInventorySettings from "./design/Setting/NewInventorySettings.jsx";
// import NewAdsTxt from "./components/NewAdsTxt.jsx";
// import NewAppAdsTxt from "./design/components/NewAppAdsTxt";
// import NewAdsTxtDesign from "./design/components/NewAdsTxtDesign.jsx";
// import NewAdstxtTable from "./design/components/NewAdstxtTable.jsx";
// import NewFullTableAdstxt from "./design/components/NewFullTableAdstxt.jsx";
// import ReportList from "./design/reportingv2/ReportList.jsx";
// import DashboardUi from "./design/dashboard/DashboardUi.jsx";
import NewMediaPlanner from "./design/newmediaplanner/NewMediaPlanner.jsx";
import NewMediaPlannerTable from "./design/newmediaplanner/NewMediaPlannerTable.jsx";
// import NewSignUpDesign from "./design/newheaderdesign/NewSignUpDesign.jsx";
import Troubleshooting from "./design/Troubleshooting/Troubleshooting.jsx";
import ZoneWithCheckbox from "./design/zonewithcheckbox/ZoneWithCheckbox.jsx";
import RowEditableComponent from "./design/zonewithcheckbox/RowEditableCom.jsx";
import WelcomeToHelix from "./design/welcomeToHelix.jsx";
import TabsForm from "./design/tabsForms.jsx";
// import ConfigureNewTask from "./design/Troubleshooting/ConfigureNewTask.jsx";
// import ManageConditions from "./design/Troubleshooting/ManageConditions.jsx";
// import ViewReportPage from "./design/Troubleshooting/ViewReportPage.jsx";
// import ViewReportPageTwo from "./design/Troubleshooting/ViewReportPageTwo.jsx";
// import KnowledgeBase from "./design/KnowledgeBase/KnowledgeBase.jsx";
// import CreateMultipleZones from "./design/CreateMultipleZones.jsx";


// Inventory: accessible only when pubStatus is not "new" AND step requirements are met
const InventoryRoute = () => {
  const { currentStep, internalStep, pubStatus, loading } = useOnboardingStep();
  if (loading) return null;
  if (!Cookies.get("token_xapads_ssp")) return <Navigate to="/login" replace />;
  if (currentStep < 2) return <Navigate to="/onboarding" replace />;
  // if ( (pubStatus === "onboard" ||  pubStatus === "rejected") && !(currentStep >= 2 && internalStep >= 4)) return <Navigate to="/onboarding" replace />;
  return <InventoryListing />;
};

// Dashboard: redirect to /onboarding for brand-new accounts only
const DashboardRoute = () => {
  const { pubStatus, loading } = useOnboardingStep();
  if (loading) return null;
  if (pubStatus === "new"||pubStatus === "rejected"||pubStatus === "onboard") return <Navigate to="/onboarding" replace />;
  return <DashboardV2 />;
};

// Register flow: accessible only when module-level store has signup data (clears on refresh)
const RegisterOnboardingRoute = () => {
  const registerFlowData = getRegisterFlowData();
  if (!registerFlowData) return <Navigate to="/login" replace />;
  return (
    <OnboardingMain
      callFrom="register"
      signupData={registerFlowData.signupData}
      pubId={registerFlowData.pubId}
    />
  );
};

const RegisterInventoryRoute = () => {
  const registerFlowData = getRegisterFlowData();
  if (!registerFlowData) return <Navigate to="/login" replace />;
  return <InventoryListing callFrom="register" pubId={registerFlowData.pubId} />;
};

// Redirects approved admin/u_admin away from onboarding back to /dashboard
const OnboardingRoute = () => {
  const { pubStatus, loading } = useOnboardingStep();
  if (loading) return null;
  if (pubStatus === "approved" || pubStatus === "archived" ||  pubStatus === "declined") return <Navigate to="/dashboard" replace />;
  return <Onboarding />;
};

function App() {
  return (
    <BrowserRouter>
      <OnboardingStepProvider>
      <Header />
      <Routes>

        <Route path="/" element={<LoginV2 />} />
        <Route path="/login" element={<LoginV2 />} />
        <Route path="/signup" element={<SignupV2 />} />

        {/*
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} /> */}
        {/* <Route path="/register" element={<Register />} /> */}

        <Route path="/onboarding" element={<OnboardingRoute />} />
        <Route path="/signup-onboarding" element={<RegisterOnboardingRoute />} />
        <Route path="/signup-inventory" element={<RegisterInventoryRoute />} />

        <Route path="/dashboard" element={<DashboardRoute />} />
        {/* <Route path="/dashboardV2" element={<Dashboard />} /> */}

        {/* <Route path="/zoneCreate" element={<ZoneCreate />} loading /> */}
        <Route path="/publisherList" element={<PublisherListing />} />
        <Route path="/inventory" element={<InventoryRoute />} />
        <Route path="/zoneList" element={<ZoneListing />} />

        <Route path="/reportingV1" element={<Reporting />} />
        <Route path="/reporting" element={<ReportV2 />} />

        <Route path="/userSyncReport" element={<UserSyncReport />} />
        {/* <Route path="/savedReports" element={<SavedReports />} /> */}
        {/* <Route path="/adsTxt" element={<AdTxtUpload />} /> */}

        <Route path="/profile" element={<MyProfile />} />

        {/* <Route path="/profileV2" element={<MyProfileV2 />} /> */}
        <Route path="/domainsMediaPlanner" element={<MediaPlanner />} />
        <Route path="/ctvMediaPlanner" element={<CTVMediaPlanner />} />
        {/* <Route path="/publisherDomain" element={<PublisherDomainListing />} /> */}
        <Route path="/mediaPlannerV2" element={<MediaPlannerV2 />} />

        <Route path="/userList" element={<AdminUserList />} />
        {/* <Route path="/users" element={<PublisherUserList />} /> */}

        <Route path="/tagHistory" element={<AdminTagList />} />
        <Route path="/domainHistory" element={<AdminDomainList />} />
        <Route path="/ctvCsvHistory" element={<AdminCtvCsvUploadList />} />
        <Route path="/adcodesHistory" element={<AdminCheckAdcodesList />} />
          <Route path="/upr" element={<UprMapper />} />

        {/* ////////////////////////////////////////////////////////Demand //////////////////////////////////////////////////////////////////// */}
        <Route path="/gamAutomation" element={<GamAutomationList />} />
        <Route path="/freewheel" element={<SiteListingFreewheel />} />
        <Route path="/pubmatic" element={<SiteListingPubmatic />} />
        <Route path="/remoteFeedList" element={<RemoteFeedListing />} />
        <Route path="/advertiser" element={<AdvertiserListing />} />
        <Route path="/campaignGam" element={<CampaignListGam />} />

        <Route path="*" element={<NoPageComponent />} />

        {/* ////////////////////////////////////////////////Healthcenter ////////////////////////////////////////////////////////////////////// */}
        <Route path="/healthcenter" element={<Healthcenter />} />
        <Route path="/knowledgeBase" element={<KnowledgeBase />} />

        {/* ////////////////////////////////////////////////////////Setting //////////////////////////////////////////////////////////////////// */}
        <Route path="/brandSafety" element={<BrandSafety />} />
        <Route path="/basicSettings" element={<BasicSetting />} />
        <Route path="/accountSettings" element={<AccountSetting />} />
        <Route path="/generalSettings" element={<GeneralSetting />} />
        <Route path="/inventorySettings" element={<InventorySetting />} />

        {/* ////////////////////////////////////////////////////////Listing Gam Demand //////////////////////////////////////////////////////////////////// */}
        <Route path="/appBundleListGam" element={<AppBundleListing />} />
        <Route path="/ipListGam" element={<IpListing />} />
        <Route path="/excludedCategoryListGam" element={<CategoryListing />} />
        <Route path="/extendedUserListGam" element={<ExtendedUserListing />} />

        {/* ////////////////////////////////////////////////////////Adstxt //////////////////////////////////////////////////////////////////// */}
        <Route path="/adsTxtListing" element={<AdsTxtMobileOps />} />
        <Route path="/adsTxtView" element={<AdsTxtPublisher />} />
        <Route path="/appAdsTxtView" element={<AppAdsTxtPublisher />} />



        {/* //////////////////////////////////////////////////////// UI Routes //////////////////////////////////////////////////////////////////////////// */}

        {/* Ui Routs */}
        {/* <Route path="/reportlist" element={<ReportList />} />
        <Route path="/components" element={<Components />} /> */}
        {/* 
           <Route path="/dashboard-ui" element={<DashboardUi />} /> */}


        {/* <Route path="/login-components" element={<LoginComponents />} />
        <Route path="/login-ui" element={<LoginUI />} />
        <Route path="/signup-ui" element={<SignupUi />} />
        <Route path="/otp-ui" element={<OtpUi />} />
        <Route path="/onboarding-ui" element={<OnboardingUi />} />
        <Route path="/onboarding-form-ui" element={<OnboardingFormUi />} />
        <Route path="/onboarding-message" element={<OnboardingMessageUi />} />
        <Route path="/publishers-listing-ui" element={<PubslishersListingUi />} />
        <Route path="/onboarding-components" element={<OnboardingComponents />} />
        <Route path="/gam-ui" element={<GamUi />} />
        <Route path="/ads-txt-ui" element={<AdsTxt />} />
        <Route path="/loader" element={<LoaderDesign />} />
        <Route path="/import-ui" element={<ImportUi />} />
        <Route path="/import-zone-ui" element={<ImportZoneUi />} />
        <Route path="/create-zone-ui" element={<CreateZoneUi />} />
        <Route path="/zone-listing-ui" element={<ZoneListingUi />} />
        <Route path="/sites-forms" element={<SitesForm />} />
        <Route path="/site-create-form" element={<SiteCreateZone />} />
        <Route path="/site-remote-form" element={<SiteRemoteForm />} />
        <Route path="/MultipleSelect" element={<MultipleSelect />} />
        <Route path="/site-create-form" element={<SiteCreateZone />} />
        <Route path="/pubmatic-web-form" element={<PubMaticWeb />} />
        <Route path="/pubmatic-app-form" element={<PubMaticApp />} />
        <Route path="/pubmatic-ctv-form" element={<PubMaticCtv />} />
        <Route path="/MultipleSelect" element={<MultipleSelect />} />
        <Route path="/create-tag-form" element={<CreateTag />} />
        <Route path="/create-tag-form2" element={<CreateTag2 />} />
        <Route path="/addon-form" element={<AddonForm/>}/>
        <Route path="/MultipleSelect" element={<MultipleSelect />} />
        <Route path="/sites-table" element={<SitesTable />} />
        <Route path="/addon-form" element={<AddonForm />} />
        <Route path="/second-form" element={<SecondForm />} />
        <Route path="/forth-form" element={<ForthForm />} />
        <Route path="/five-form-table" element={<FiveFormTable />} />
        <Route path="/ExcludedCategoriesForm" element={<ExcludedCategoriesForm />} />
        <Route path="/IpList" element={<IpList />} />
        <Route path="/NewExtendedUserList" element={<NewExtendedUserList />} />
        <Route path="/CreateAppBundleList" element={<CreateAppBundleList />} />
        <Route path="/media-filter" element={<MediaPlannerFilter />} />
        <Route path="/gem-table" element={<GemTable />} />
        <Route path="/fifth-form" element={<FifthForm />} />
        <Route path="/edit-campaign" element={<EditCampaign />} />
        <Route path="/media-listing" element={<MediaPlannerListing />} />
        <Route path="/create-advertiser" element={<CreateAdvertiser />} /> */}
        {/* 
        <Route path="/first-form" element={<FirstForm />} />
        <Route path="/forth-form" element={<ForthForm />} />
        <Route path="/new-publishers-form" element={<NewPublishersForm />} /> */}


        {/* 
        <Route path="/new-brand-safety" element={<NewBrandSafety />} />
        <Route path="/new-my-account" element={<NewMyAccount />} />
        <Route path="/new-inventory-settings" element={<NewInventorySettings />} />
        <Route path="/new-ads-txt" element={<NewAdsTxt />} />
        <Route path="/new-app-ads-txt" element={<NewAppAdsTxt />} />
        <Route path="/new-design-ads-txt" element={<NewAdsTxtDesign />} />
        <Route path="/new-ads-txt-table" element={<NewAdstxtTable />} />
        <Route path="/new-ads-txt-full-table" element={<NewFullTableAdstxt />} /> */}

        {/* <Route path="/reportlist" element={<ReportList />} /> */}
        {/* 
        <Route path="/components" element={<Components />} />
        <Route path="/new-inventory" element={<NewInventoryPage />} />
        <Route path="/new-signup" element={<NewSignUpDesign />} /> */}

        {/* 
        <Route path="/first-form" element={<FirstForm />} /> */}

        {/* <Route path="/trouble-shooting" element={<Troubleshooting />} />
        <Route path="/configure-newtask" element={<ConfigureNewTask />} />
        <Route path="/manage-conditions" element={<ManageConditions />} />
         */}
        {/* 
        <Route path="/new-inventory" element={<NewInventoryPage />} />
        
        <Route path="/components" element={<Components />} /> */}

        {/* <Route path="/create-multiple-zones" element={<CreateMultipleZones />} /> */}
        {/* 
         <Route path="/view-report" element={<ViewReportPage />} />
        <Route path="/view-report-two" element={<ViewReportPageTwo />} />
        <Route path="/new-mp" element={<NewMediaPlanner />} />
        <Route path="/new-mp-table" element={<NewMediaPlannerTable />} /> 
        
        <Route path="/zone-with-checkbox" element={<ZoneWithCheckbox />} />
        <Route path="/row-editable" element={<RowEditableComponent />} /> */}


        <Route path="/welcome-helix" element={<WelcomeToHelix />} />
        <Route path="/tabs-form" element={<TabsForm />} />

        {/* <Route path="/forth-form" element={<ForthForm />} /> */}
        {/* <Route path="/third-form" element={<ThirdForm />} /> */}


      </Routes>
      </OnboardingStepProvider>
    </BrowserRouter>
  );
}

export default App; 